import { memo } from 'react'
import { LinearGradient } from './LinearGradient'
import { Image } from './Image'

interface Props {
  coverImageUrl: string | null
  profileImageUrl: string | null
  userId: number
  alt: string
}

const CoverImage = ({ coverImageUrl, profileImageUrl, userId, alt }: Props) => {
  if (coverImageUrl) {
    return <Image alt={alt} src={coverImageUrl} size={300} />
  }

  if (profileImageUrl) {
    return <Image alt={alt} src={profileImageUrl} blurred />
  }

  return <LinearGradient userId={userId} />
}

const MemoizedProfileImage = memo(CoverImage)

export { MemoizedProfileImage as CoverImage }
